module.exports = __webpack_public_path__ + "img/report_page_navigation.fc6fc6f5.svg";